<template>
  <BaseSimpleModal
    v-if="isDesktop"
    v-model:modal-show="showModal"
    custom-class="!w-[460px] !pt-[30px] !px-[30px] !pb-[60px]"
  >
    <template #content>
      <AuthBaseCard
        :title="t(cardTitle)"
        :disable-back-button="showFirstStep"
        class="mt-10"
        @go-back="goBack"
      >
        <div v-if="showFirstStep" class="mb-4">
          <slot name="googleSignin">
            <div></div>
          </slot>
        </div>
        <AuthFirstStepOptions
          v-if="showFirstStep"
          is-desktop
          @show-email-form="goToEmailStep"
        />
        <template v-else-if="showLoginOrRegisterForm">
          <div v-show="userStatus === null">
            <AuthLogin
              ref="loginForm"
              v-model:email="email"
              v-model:show-password="showPassword"
              @check="checkEmail"
              @close="close"
              @open-forgot="goToForgot"
            />
          </div>
          <AuthRegister
            v-show="userStatus === 1"
            :email="email"
            @close="close"
          />
        </template>
        <AuthForgot
          v-else-if="showForgotForm"
          :email="email"
          @done-forgot="doneForgot"
        />
      </AuthBaseCard>
    </template>
  </BaseSimpleModal>

  <BaseBottomSheet v-else v-model:show="showModal" full-height>
    <AuthBaseCard
      :title="t(cardTitle)"
      :disable-back-button="showFirstStep"
      class="mt-6 pb-10 max-md:max-h-[calc(100vh-58px)] max-md:overflow-scroll"
      @go-back="goBack"
    >
      <div v-if="showFirstStep" class="mb-4">
        <slot name="googleSignin">
          <div></div>
        </slot>
      </div>
      <AuthFirstStepOptions
        v-if="showFirstStep"
        @show-email-form="goToEmailStep"
      />
      <template v-else-if="showLoginOrRegisterForm">
        <div v-show="userStatus === null">
          <AuthLogin
            ref="loginForm"
            v-model:email="email"
            v-model:show-password="showPassword"
            @check="checkEmail"
            @close="close"
            @open-forgot="goToForgot"
          />
        </div>
        <AuthRegister v-show="userStatus === 1" :email="email" @close="close" />
      </template>
      <AuthForgot
        v-else-if="showForgotForm"
        :email="email"
        @done-forgot="doneForgot"
      />
    </AuthBaseCard>
  </BaseBottomSheet>
</template>

<script setup lang="ts">
import { EmailStatus } from "../../utils/enum";
import { computed, onMounted, ref, watch } from "vue";
const { t } = useI18n();

const showModal = ref<boolean>(false);
const showFirstStep = ref<boolean>(false);
const showForgotForm = ref<boolean>(false);
const showLoginOrRegisterForm = ref<boolean>(false);
const email = ref();
const userStatus = ref<EmailStatus | null>(null);
const isDesktop = ref(false);

watch(
  () => showModal.value,
  (newVal) => {
    if (!newVal) {
      userStatus.value = null;
    }
  }
);

const cardTitle = computed(() => {
  return showFirstStep.value
    ? "auth.welcome"
    : showLoginOrRegisterForm.value
      ? userStatus.value === null
        ? "auth.signIn"
        : "auth.signUp"
      : "";
});

const open = () => {
  showModal.value = true;
  showFirstStep.value = true;
};

const close = () => {
  showModal.value = false;
  showLoginOrRegisterForm.value = false;
  userStatus.value = null;
};
const showPassword = ref(false);
// function changePasswordFlag(val: boolean) {
//   passwordFlag.value = val;
// }
const goBack = () => {
  if (showLoginOrRegisterForm.value) {
    if (userStatus.value === null) {
      if (showPassword.value) {
        showPassword.value = false;
      } else {
        showLoginOrRegisterForm.value = false;
        showFirstStep.value = true;
        userStatus.value = null;
      }
    } else {
      userStatus.value = null;
    }
  } else if (showForgotForm.value) {
    showLoginOrRegisterForm.value = true;
    showForgotForm.value = false;
  }
};

const goToForgot = () => {
  showLoginOrRegisterForm.value = false;
  showForgotForm.value = true;
};

const goToEmailStep = () => {
  showLoginOrRegisterForm.value = true;
  showFirstStep.value = false;
};

const checkEmail = (status: EmailStatus) => {
  userStatus.value = status;
};

function doneForgot() {
  showForgotForm.value = false;
  showFirstStep.value = true;
}

const handleResize = () => {
  isDesktop.value = window.innerWidth >= 768;
};

onMounted(() => {
  handleResize();
});

defineExpose({
  goToEmailStep,
  open,
});
</script>
